import Cookies from "js-cookie";

import { PageLoadHook } from "../core/PageLoadHook.mjs";

export class AgeValidation extends PageLoadHook {
  static ValidatedCookieName = "AgeValidated";
  static RememberValidatedCookieName = "RememberAgeValidated";

  get ageOverlay() {
    if (!this._ageOverlay) {
      this._ageOverlay = document.querySelector(".age-overlay");
    }
    return this._ageOverlay;
  }

  get acceptButton() {
    if (!this._acceptButton) {
      this._acceptButton = document.getElementById("age-overlay-accept-button");
    }
    return this._acceptButton;
  }

  get rejectButton() {
    if (!this._rejectButton) {
      this._rejectButton = document.getElementById("age-overlay-reject-button");
    }
    return this._rejectButton;
  }

  get rememberMeCheckbox() {
    if (!this._rememberMeCheckbox) {
      this._rememberMeCheckbox = document.getElementById(
        "age-overlay-remember-me-checkbox",
      );
    }
    return this._rememberMeCheckbox;
  }

  onPageLoad() {
    if (Cookies.get(AgeValidation.ValidatedCookieName)) {
      this.ageOverlay.classList.add("age-validated");
      if (Cookies.get(AgeValidation.RememberValidatedCookieName)) {
        Cookies.set(AgeValidation.ValidatedCookieName, "true", {
          expires: 365,
          sameSite: "strict",
        });
        Cookies.set(AgeValidation.RememberValidatedCookieName, "true", {
          expires: 365,
          sameSite: "strict",
        });
      }
      return;
    }

    this.ageOverlay.classList.add("age-validation-required");

    this.acceptButton.onclick = () => {
      this._onAccept();
    };

    this.rejectButton.onclick = () => {
      this._onReject();
    };
  }

  _onAccept() {
    this.ageOverlay.classList.add("age-validated");
    Cookies.set(AgeValidation.ValidatedCookieName, "true", {
      expires: this.rememberMeCheckbox.checked ? 365 : undefined,
      sameSite: "strict",
    });

    if (this.rememberMeCheckbox.checked) {
      Cookies.set(AgeValidation.RememberValidatedCookieName, "true", {
        expires: 365,
        sameSite: "strict",
      });
    }
  }

  _onReject() {
    window.location.assign("https://google.com/");
  }
}
